import { CreatedInterfaces } from 'interfaces';
import { useGetRequest } from './utils/useGetRequest';

const resource = 'transactions';

const useGetTransactions = (
  cardId: string,
  startDate: string,
  endDate: string,
  pageSize: number,
  pageIndex: number
) => {
  const [{ data, error, loading: isLoading }] = useGetRequest<CreatedInterfaces<typeof resource>>({
    path: `v2/transactions?card_id=${cardId}&start_date=${startDate}Z&end_date=${endDate}Z&page=${pageIndex}&size=${pageSize}`,
  });


  return {
    transactions: data?.data.filter((trx) => trx.authorization.info.transaction.type !== 'COMPLETION'),
    pageInfo: {
      ...data?.meta,
      total: (data?.meta.size ?? 0) * (data?.meta.total ?? 0),
    },
    isLoading,
    isError: error,
  };
};

export default useGetTransactions;
